// 线上图片地址
export const imgUrl = 'https://www.hzinvest.cn/uploads/'